import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IconArrowRightWide } from '../../../../../icons/arrow-right-wide';
import { IconButton } from '../../../../../icon/button/icon-button';
import { CardTitle } from '../../../../../card/title/card-title';
import { SkeletonDashboardCardsDividendsContent } from './content/skeleton-dashboard-cards-dividends-content';

export const SkeletonDashboardCardsDividends: React.FC = observer(() => {
    const { t } = useTranslation();

    const getActions = () => {
        return (
            <div className="flex items-center gap-xsmall">
                <IconButton icon={<IconArrowRightWide />} variant={'default'} variation={'outlined'} size={'small'} />
            </div>
        );
    };

    return (
        <div className="relative flex h-full min-h-[18rem] flex-col justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[url('/images/card-stats/dividends-bg.svg')] max-md:bg-[length:auto_10rem] max-md:bg-[position:100%_100%] max-md:bg-no-repeat">
            <CardTitle title={t('layout.statisticsCard.dividends.title')} actions={getActions()} />
            <SkeletonDashboardCardsDividendsContent
                yieldLabel={t('layout.statisticsCard.dividends.yield')}
                yieldOnCostLabel={t('layout.statisticsCard.dividends.yieldOnCost')}
                predictionLabel={t('layout.statisticsCard.dividends.prediction')}
                payoutLabel={t('layout.statisticsCard.dividends.payout')}
            />
        </div>
    );
});
